import { classify } from 'sidecar-utilities'

export const messageStyles = 'flex gap-3 mb-6 last:mb-0'

export const thumbnailStyles = isMember =>
  classify({
    flex: 'flex justify-center items-center shrink-0',
    spacing: 'mt-3',
    size: 'w-8 h-8',
    borderRadius: 'rounded-full overflow-hidden',
    // If the author is the member, make the thumbnail blue, otherwise make it grey
    color: isMember
      ? 'color-accent-default color-textOnAccent-heavy-default'
      : 'color-inverse-weak-default color-textOnInverse-weak-default',
  })

export const botAvatarStyles = 'w-8 h-8 mt-3'

export const bubbleWrapperStyles = showTitle =>
  classify({
    default: 'w-full',
    // If it's show title, keep the title above the bubble.
    // If it's not, move the footer date to the right of the bubble on large screens.
    moveDate: !showTitle ? 'lg:flex lg:gap-3 lg:items-start' : null,
  })

export const bubbleStyles = isMember =>
  classify({
    layout: 'w-full p-4 overflow-clip',
    border: 'rounded-md',
    // If the author is the member, make the bubble blue, otherwise make it grey
    bgColor: isMember
      ? `color-background-accent
      color-textOnAccent-default
      [&_.sh-body-sm]:color-textOnAccent-weak-default
      [&_svg.inherit]:color-iconOnAccent-default`
      : 'color-background-weak color-textOnDefault',
    children: isMember
      ? `[&_thead]:color-background-accent
       [&_table_thead_th:first-child]:after:color-background-accent
       [&_table_thead_th:last-child]:after:color-background-accent`
      : `[&_thead]:color-background-weak
       [&_table_thead_th:first-child]:after:color-background-weak
       [&_table_thead_th:last-child]:after:color-background-weak`,
  })

export const dateStyles = 'sh-body-xs pt-2 lg:pt-3 lg:w-24'
